import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  Action,
  ActionDetail,
  ActionStaus,
  ActionWallet,
  ActionWrapper,
  ProfileImageWrapper,
  UserInfo,
} from "./StyledUserDetails";

const UserSkeleton = () => {
  return (
    <>
      <UserInfo>
        <ActionWrapper>
          <ProfileImageWrapper>
            <Skeleton height={350} width={300} />
          </ProfileImageWrapper>
          <Action>
          <Skeleton height={30} width={300}  count={2} style={{marginBottom:"10px"}} />
          </Action>
        </ActionWrapper>

          <div>
          <Skeleton height={35} width={200} style={{marginTop:"20px", marginBottom:"10px"}} />
          <Skeleton height={25} width={300} style={{marginTop:"10px"}} count={10}/>
          
          
          </div>
      </UserInfo>
    </>
  );
};

export default UserSkeleton;
